import { Block } from 'webiq.boilerplate'

export default class BackgroundClipPath extends Block {
	static title = 'bg-clip-path'

	init() {
        const textSpan = this.element.querySelector('span');
        const container = this.element;

        let PADDING_Y
        let PADDING_LEFT
        let PADDING_RIGHT
        let SKEW_AMOUNT

        // Padding waarden (gelijk aan py-1, pl-2, pr-4 in Tailwind units / 4)
        if (this.hasModifier('small')) {
            PADDING_Y = 4; // 0.25rem * 16px/rem = 4px (py-1)
            PADDING_LEFT = 8; // 0.5rem * 16px/rem = 8px (pl-2)
            PADDING_RIGHT = 20; // 1rem * 16px/rem = 16px (pr-4)
            SKEW_AMOUNT = 20; // Hoeveel pixels de schuine kant inneemt
        } else {
            PADDING_Y = 4; // 0.25rem * 16px/rem = 4px (py-1)
            PADDING_LEFT = 8; // 0.5rem * 16px/rem = 8px (pl-2)
            PADDING_RIGHT = 50; // 1rem * 16px/rem = 16px (pr-4)
            SKEW_AMOUNT = 50; // Hoeveel pixels de schuine kant inneemt
        }

        function createSkewedBackgrounds() {
            // Verwijder oude achtergronden
            const oldBgs = container.querySelectorAll('.line-bg');
            oldBgs.forEach(bg => bg.remove());

            // Haal de positie van de container op (voor relatieve positionering)
            const containerRect = container.getBoundingClientRect();

            // Haal de rechthoeken op van elk tekstfragment (elke regel)
            const clientRects = textSpan.getClientRects();

            for (let i = 0; i < clientRects.length; i++) {
                const rect = clientRects[i];

                // Sla over als de rect geen dimensies heeft (gebeurt soms)
                if (rect.width === 0 || rect.height === 0) continue;

                const bgDiv = document.createElement('div');
                bgDiv.classList.add('line-bg');

                // Bereken positie en grootte INCLUSIEF padding
                const top = rect.top - containerRect.top - PADDING_Y;
                const left = rect.left - containerRect.left - PADDING_LEFT;
                const width = rect.width + PADDING_LEFT + PADDING_RIGHT;
                const height = rect.height + (PADDING_Y * 2);

                bgDiv.style.top = `${top}px`;
                bgDiv.style.left = `${left}px`;
                bgDiv.style.width = `${width}px`;
                bgDiv.style.height = `${height}px`;

                // Pas clip-path aan op basis van de berekende breedte
                // Zorg dat de skew amount niet groter is dan de breedte
                const actualSkew = Math.min(SKEW_AMOUNT, width * 0.5); // Max 50% skew
                bgDiv.style.clipPath = `polygon(0% 0%, 100% 0%, calc(100% - ${actualSkew}px) 100%, 0% 100%)`;

                container.appendChild(bgDiv);
            }
        }

        // Debounce functie om resize niet te vaak te triggeren
        function debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        const debouncedUpdate = debounce(createSkewedBackgrounds, 100); // Wacht 100ms na resize

        // Voer initieel uit
        window.addEventListener('load', createSkewedBackgrounds);
        // Voer uit bij resize
        window.addEventListener('resize', debouncedUpdate);
	}
}
